import { memo } from 'react';
import { useSliderValue } from './SliderContext.js';
import FillTemplate from './FillTemplate.js';
import { jsx } from 'react/jsx-runtime';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@dtvgo/utils';
import './utils.js';
import '@dtvgo/classnames';

/* External */
function Fill(_ref) {
  var className = _ref.className,
    style = _ref.style,
    flat = _ref.flat,
    lowerValue = _ref.lowerValue;
  var value = useSliderValue();
  return /*#__PURE__*/jsx(FillTemplate, {
    className: className,
    style: style,
    lowerValue: lowerValue,
    value: value,
    flat: flat
  });
}
Fill.defaultProps = {
  className: '',
  style: {},
  flat: false,
  lowerValue: 0
};
var Fill$1 = /*#__PURE__*/memo(Fill);

export { Fill$1 as default };
//# sourceMappingURL=Fill.js.map
